module.exports = __webpack_public_path__ + "static/media/chevron-left.b18764a3.svg";